<template>
  <div class="header">
    <a href="http://test1.smartclass.cn/Default.aspx" target="_blank"><img src="http://test1.smartclass.cn/images/publicImg/hanboerYun_logo_04.png" alt=""></a>
  </div>
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped>
  .header{
    height:50px;
    background:#0090fc
  }
  .header a img{
    margin-top:10px;
    margin-left:20px;
    cursor: pointer;
    height:30px;
  }
</style>



// WEBPACK FOOTER //
// src/components/common/Header.vue